/**
 * Token迁移工具类
 * 用于将token从cookie迁移到localStorage
 */
class TokenMigrator {
  /**
   * 从cookie获取token
   * @param {string} cookieName cookie名称
   * @returns {string|null} token值
   */
  static getTokenFromCookie(cookieName) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${cookieName}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  /**
   * 设置localStorage token
   * @param {string} token token值
   * @param {string} storageKey localStorage键名
   */
  static setTokenToLocalStorage(token, storageKey) {
    localStorage.setItem(storageKey, token);
  }

  /**
   * 从cookie迁移token到localStorage
   * @param {string} cookieName cookie名称
   * @param {boolean} removeCookie 是否删除cookie
   * @returns {string|null} 迁移的token
   */
  static migrateToLocalStorage(cookieName, removeCookie = true) {
    try {
      // 从cookie获取token
      const token = this.getTokenFromCookie(cookieName);
      
      if (token) {
        // 设置到localStorage
        this.setTokenToLocalStorage(token, cookieName);
        
        // 如果需要，删除cookie
        if (removeCookie) {
          document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
        }
        
        console.log(`成功从cookie迁移token到localStorage: ${cookieName}`);
        return token;
      }
      
      return null;
    } catch (error) {
      console.error(`Token迁移失败: ${error.message}`);
      return null;
    }
  }

  /**
   * 批量迁移多个token
   * @param {string[]} cookieNames cookie名称数组
   * @param {boolean} removeCookie 是否删除cookie
   * @returns {Object} 迁移结果
   */
  static batchMigrate(cookieNames, removeCookie = true) {
    const results = {};
    
    cookieNames.forEach(cookieName => {
      results[cookieName] = this.migrateToLocalStorage(cookieName, removeCookie);
    });
    
    return results;
  }

  /**
   * 检查是否需要进行token迁移
   * @param {string} cookieName cookie名称
   * @returns {boolean} 是否需要迁移
   */
  static needsMigration(cookieName) {
    const cookieToken = this.getTokenFromCookie(cookieName);
    const localStorageToken = localStorage.getItem(cookieName);
    
    // 如果cookie中有token但localStorage中没有，则需要迁移
    return cookieToken && !localStorageToken;
  }

  /**
   * 获取所有可能的token cookie名称
   * @returns {string[]} token cookie名称数组
   */
  static getPossibleTokenNames() {
    return [
      'katoken',
      'token',
      'access_token',
      'auth_token',
      'session_token',
      'sso_token'
    ];
  }

  /**
   * 自动迁移所有可能的token
   * @param {boolean} removeCookie 是否删除cookie
   * @returns {Object} 迁移结果
   */
  static autoMigrateAll(removeCookie = true) {
    const tokenNames = this.getPossibleTokenNames();
    const results = {};
    
    tokenNames.forEach(tokenName => {
      if (this.needsMigration(tokenName)) {
        results[tokenName] = this.migrateToLocalStorage(tokenName, removeCookie);
      } else {
        results[tokenName] = '无需迁移';
      }
    });
    
    return results;
  }
}

export default TokenMigrator;
